import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"20%"} }
const _hoisted_2 = { style: {"width":"20%"} }

import SogGrid from "@/shared/ui/SogGrid.vue";
import {onMounted, reactive, ref, watch} from "vue";
import {Api} from "@/shared/services/api";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DefaultColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import {storeToRefs} from "pinia";
import {useInsuranceExportBlankStore} from "@/modules/InsuranceExportBlank/store";
import {useNavigationStore} from "@/modules/Navigation/store";
import {
  InsuranceExportBlankStatus,
  PrintType,
} from "@/shared/model/InsuranceExportBlank";
import {IdType} from "@/shared/model/idType";
import {onBeforeRouteUpdate} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListPage',
  setup(__props) {

const _grid = ref<InstanceType<typeof SogGrid> | null>(null);
const _url = Api.baseUrl + "/InsuranceExportBlankList";
const _buttonId = ref("");
const _lstYes = reactive([
  {id: InsuranceExportBlankStatus.Canceled, value: "ungültig"},
  {
    id: InsuranceExportBlankStatus.Archived,
    value: "archiviert",
  },
  {
    id: InsuranceExportBlankStatus.Destroyed,
    value: "vernichtet",
  },
  {
    id: InsuranceExportBlankStatus.IncorrectlyFilled,
    value: "falsch ausgefüllt",
  },
  {id: "all", value: "Alle"},
]);
const _listDruck = reactive([
  {id: PrintType.PrePrinted, value: "Vorgedruckt"},
  {
    id: PrintType.FullPrinted,
    value: "Vollständiggedruckt",
  },
  {
    id: "",
    value: "nicht gedruckt",
  },
  {id: "all", value: "Alle"},
]);
const _fields = {text: "value", value: "id"};
const _insuranceExportBlankStore = useInsuranceExportBlankStore();
const {listPage: _listPage} = storeToRefs(_insuranceExportBlankStore);
const _navigationStore = useNavigationStore();

const _columns: ColumnModel[] = [
  {
    ...DefaultColumn,
    headerText: "",
    visible: true,
    commands: [
      {
        buttonOption: {
          cssClass: "e-flat",
          iconCss: "e-circle-info e-icons",
          click: onClickDetails,
        },
      },
    ],
    textAlign: "Left",
    uid: "details",
    autoFit: true,
    width: "60px",
  },
  {...DefaultColumn, field: "blankNumber", headerText: "Formularnummer"},
  {...DefaultColumn, field: "insuranceNumber", headerText: "VSNR"},
  {
    ...DefaultColumn,
    field: "printTypeDescription",
    headerText: "Druckstatus",
    allowSorting: false,
  },
  {
    ...DefaultColumn,
    field: "statusDescription",
    headerText: "Zustand",
    allowSorting: false,
  },
  {
    ...DefaultColumn,
    field: "manufacturerName",
    headerText: "Versicherer",
    allowSorting: false,
  },
];

async function onClickDetails() {
  _buttonId.value = "details";
}

function search() {
  if (!_grid.value || !_grid.value.adaptor) return;
  _grid.value?.adaptor?.removePredicate("number");
  if (_listPage.value.number) {
    _grid.value?.adaptor.addPredicate(
      "number",
      "contains",
      _listPage.value.number.toUpperCase()
    );
  }

  _grid.value?.adaptor?.removePredicate("status");
  if (_listPage.value.status !== "all") {
    _grid.value?.adaptor.addPredicate(
      "status",
      "equal",
      _listPage.value.status
    );
  }

  _grid.value?.adaptor?.removePredicate("printType");
  if (_listPage.value.printType !== "all") {
    _grid.value?.adaptor.addPredicate("printType", "equal", _listPage.value.printType);
  }
  _grid.value.refresh();
}

onMounted(() => {
  search();
});


onBeforeRouteUpdate(async () => {
  search();
});


watch(_listPage.value, () => {
    search();
});


async function onClick(args: any) {
  _navigationStore.currentOrderNumber = args.rowData.orderNumber;
  if (_buttonId.value === "details") {
    await _navigationStore.showObject(IdType.InsuranceExportBlank, args.rowData.id);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Ausfuhrformulare" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPage).number,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_listPage).number) = $event)),
                placeholder: "Nummer"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_listPage).status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(_listPage).status) = $event)),
                  placeholder: "Zustand",
                  "data-source": _lstYes,
                  fields: _fields,
                  "popup-width": "auto"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_listPage).printType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(_listPage).printType) = $event)),
                  placeholder: "Druckstatus",
                  "data-source": _listDruck,
                  fields: _fields,
                  "popup-width": "auto"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Search,
                style: {"align-self":"flex-end"},
                onClick: search
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back,
                style: {"align-self":"flex-end"}
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                id: "ausfuhrList",
                ref_key: "_grid",
                ref: _grid,
                url: _url,
                columns: _columns,
                width: "auto",
                "on-command-click": onClick,
                "refresh-on-mount": false
              }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})